import '../styles/pages/error.scss'
import React from "react";
import { useRouteError } from 'react-router-dom';

export default function ErrorBoundary() {
    const error = useRouteError();
    console.error(error);
    return (
        <div id='error-boundary'>
            <img src={require('../assets/images/logo.svg').default} alt="Palmona Dashboard logo"/>
            <p>Something went wrong! Error code: {error.status}</p>
        </div>
    )
}